(function () {
  if (window.innerWidth > 768) return;

  // Hero carousel
  function initHeroCarousel() {
    const track = document.querySelector('.ziba-hero__track');
    const dots = document.querySelectorAll('.ziba-hero__dot');

    if (!track || dots.length === 0) return;

    track.addEventListener('scroll', function () {
      const index = Math.round(track.scrollLeft / track.offsetWidth);
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    });
  }

  // Variant pills — shared state across all option groups (Tür, Ağırlık, vb.)
  const ziba = { variants: [], prices: {}, selected: {} };

  function loadZibaVariantData() {
    const dataEl = document.querySelector('[data-ziba-variants]');
    if (!dataEl) return;

    try {
      const parsed = JSON.parse(dataEl.textContent);
      ziba.variants = parsed.variants || [];
      ziba.prices = parsed.prices || {};
    } catch (e) {
      ziba.variants = [];
      ziba.prices = {};
    }

    // Seed selection state from the server-rendered "selected" pill per group
    document.querySelectorAll('.ziba-variants').forEach(group => {
      const pos = group.dataset.optionPosition;
      const current = group.querySelector('.ziba-variants__pill.selected');
      if (current) ziba.selected[pos] = current.dataset.value;
    });
  }

  function resolveVariant() {
    return ziba.variants.find(v => {
      return (!ziba.selected['1'] || v.option1 === ziba.selected['1'])
        && (!ziba.selected['2'] || v.option2 === ziba.selected['2'])
        && (!ziba.selected['3'] || v.option3 === ziba.selected['3']);
    });
  }

  function updateCtaLabel(price, available) {
    const ctaBtn = document.querySelector('.ziba-cta__add');
    if (!ctaBtn || !price) return;

    const bundle3for2 = document.querySelector('#bundle-3for2');
    if (bundle3for2 && bundle3for2.checked) {
      const priceNum = parseFloat(price.replace(/[^0-9.,]/g, '').replace(',', '.'));
      const total = (priceNum * 3).toFixed(2);
      const currency = price.match(/[^\d.,\s]+/g);
      const currencySymbol = currency ? currency[0] : '₺';
      ctaBtn.innerHTML = `<svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>3 Adet Ekle — ${currencySymbol}${total}`;
    } else {
      ctaBtn.innerHTML = `<svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>Sepete Ekle — ${price}`;
    }
    ctaBtn.disabled = !available;
  }

  function applyResolvedVariant() {
    const variant = resolveVariant();
    if (!variant) return;

    const priceEl = document.querySelector('.ziba-product__price');
    const priceText = ziba.prices[String(variant.id)];
    if (priceEl && priceText) priceEl.textContent = priceText;

    const variantInput = document.querySelector('[name="id"]');
    if (variantInput) variantInput.value = variant.id;

    updateCtaLabel(priceText, variant.available);
  }

  function initVariantPills() {
    loadZibaVariantData();

    document.querySelectorAll('.ziba-variants__pill').forEach(pill => {
      pill.addEventListener('click', function () {
        if (this.classList.contains('disabled')) return;

        const group = this.closest('.ziba-variants');
        const pos = group.dataset.optionPosition;

        group.querySelectorAll('.ziba-variants__pill').forEach(p => p.classList.remove('selected'));
        this.classList.add('selected');
        ziba.selected[pos] = this.dataset.value;

        applyResolvedVariant();
      });
    });
  }

  // Accordions
  function initAccordions() {
    const accordions = document.querySelectorAll('.ziba-accordion__header');

    accordions.forEach(header => {
      header.addEventListener('click', function () {
        const accordion = this.closest('.ziba-accordion');
        const isOpen = accordion.classList.contains('open');

        // Close all
        document.querySelectorAll('.ziba-accordion').forEach(acc => {
          acc.classList.remove('open');
        });

        // Toggle current
        if (!isOpen) {
          accordion.classList.add('open');
        }
      });
    });

    // Open first accordion by default
    const firstAccordion = document.querySelector('.ziba-accordion');
    if (firstAccordion) {
      firstAccordion.classList.add('open');
    }
  }

  // Bundle 3for2
  function initBundle() {
    const checkbox = document.querySelector('#bundle-3for2');
    if (!checkbox) return;

    checkbox.addEventListener('change', function () {
      const variant = resolveVariant();
      if (!variant) return;
      updateCtaLabel(ziba.prices[String(variant.id)], variant.available);
    });
  }

  // Add to cart
  function initAddToCart() {
    const ctaBtn = document.querySelector('.ziba-cta__add');
    const favoriteBtn = document.querySelector('.ziba-cta__favorite');

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        const variantSelect = document.querySelector('[name="id"]');
        const bundle3for2 = document.querySelector('#bundle-3for2');

        if (!variantSelect || !variantSelect.value) {
          showToast('Lütfen bir seçenek belirleyin');
          return;
        }

        const quantity = bundle3for2 && bundle3for2.checked ? 3 : 1;

        ctaBtn.disabled = true;
        const originalText = ctaBtn.innerHTML;
        ctaBtn.innerHTML = '<svg style="width:20px;height:20px;animation:spin 1s linear infinite" fill="none" viewBox="0 0 24 24"><circle style="opacity:0.25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path style="opacity:0.75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>Ekleniyor...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantSelect.value,
            quantity: quantity
          })
        })
          .then(res => res.json())
          .then(addedItem => {
            // Update cart badges everywhere
            return fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                // Update all cart count badges
                document.querySelectorAll('[data-cart-count], .mobile-bottom-nav__badge, .header__cart-badge, .ziba-topbar__badge').forEach(el => {
                  el.textContent = cart.item_count;
                  el.removeAttribute('hidden');
                  el.style.display = '';
                });

                showToast(quantity > 1 ? `${quantity} adet sepete eklendi!` : 'Sepete eklendi!');

                // Dispatch event for CartDrawer to open + refresh
                document.dispatchEvent(new CustomEvent('cart:item-added', {
                  detail: { item: addedItem },
                  bubbles: true
                }));

                ctaBtn.disabled = false;
                ctaBtn.innerHTML = originalText;
              });
          })
          .catch(err => {
            console.error('Add to cart error:', err);
            showToast('Hata oluştu');
            ctaBtn.disabled = false;
            ctaBtn.innerHTML = originalText;
          });
      });
    }

    if (favoriteBtn) {
      favoriteBtn.addEventListener('click', function () {
        this.classList.toggle('active');
        const isActive = this.classList.contains('active');
        showToast(isActive ? 'Favorilere eklendi' : 'Favorilerden çıkarıldı');
      });
    }
  }

  // Toast
  function showToast(message) {
    let toast = document.querySelector('.ziba-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ziba-toast';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  // Init all
  document.addEventListener('DOMContentLoaded', function () {
    initHeroCarousel();
    initVariantPills();
    initAccordions();
    initBundle();
    initAddToCart();
  });
})();
